import React from 'react'

import * as MdIcons from 'react-icons/md'
import { useTheme } from 'styled-components'

import { Separator } from '@components/Separator'
import { IBarrier } from '@interfaces/task/barrier'

import {
  BarrierCardContainer,
  CardBody,
  CardFooter,
  CardHeader,
  InfoContainer,
  Label,
  SeparatorContainer,
  Title,
  Value,
  ViewCommentsContainer,
  ViewCommentsLink,
} from './styles'

interface IBarrierCardProps {
  barrier: IBarrier
  onEditBarrier: () => void
  onCommentsPress: () => void
  isReadOnly?: boolean
}

export function BarrierCard({
  barrier,
  onEditBarrier,
  onCommentsPress,
  isReadOnly,
}: IBarrierCardProps) {
  const { colors } = useTheme()

  return (
    <BarrierCardContainer>
      <CardHeader>
        <Title>{barrier.barrierCode.description}</Title>

        {!isReadOnly && (
          <button onClick={onEditBarrier} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', margin: '-8px -8px 0 0', minWidth: 44, minHeight: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MdIcons.MdMoreVert size={24} color={colors.text} />
          </button>
        )}
      </CardHeader>

      <div>
        <CardBody>
          <InfoContainer>
            <MdIcons.MdAccessTime size={24} color={colors.text} />
            <Label>Hours lost</Label>
            <Value>{barrier.hoursLost}</Value>
            <Value></Value>
          </InfoContainer>
          <InfoContainer>
            <MdIcons.MdDescription size={24} color={colors.text} />
            <Label>Was caused by previous shift?</Label>
            <Value>{barrier.wasCausedByPreviousShift ? 'Yes' : 'No'}</Value>
          </InfoContainer>
        </CardBody>

        <SeparatorContainer>
          <Separator />
        </SeparatorContainer>

        <CardFooter onClick={onCommentsPress}>
          <ViewCommentsContainer>
            <MdIcons.MdChatBubbleOutline size={24} color={colors.textLink} />
            <ViewCommentsLink>
              View {barrier.comments && barrier.comments.length} comments / Add
              Comments
            </ViewCommentsLink>
          </ViewCommentsContainer>
        </CardFooter>
      </div>
    </BarrierCardContainer>
  )
}
